import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ProgressIndicator extends Component {
  determineActiveSection(sectionNumber) {
    let className = '';
    if (sectionNumber <= this.props.sectionActive) {
      className = 'active-section';
    }
    return className;
  }

  renderSection(sectionNumber) {
    const { progressText } = this.props;
    return (
      <div key={sectionNumber} className="progress-indicator__section-wrap">
        <div className={`progress-indicator__section ${this.determineActiveSection(sectionNumber)}`}>
          <div className="progress-indicator__label-number">
            {sectionNumber}
          </div>
        </div>
        <div className="progress-indicator__label-title">
          <div className="multi-line">
            {progressText[sectionNumber].line1}
            <br/>
            {progressText[sectionNumber].line2}
          </div>
          <div className="single-line">
            {`${progressText[sectionNumber].line1} ${progressText[sectionNumber].line2 == "Information" ? "Info" : progressText[sectionNumber].line2}`}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const totalSectionsArray =
      Array(this.props.totalSections).fill().map((_, idx) => 1 + idx);

    return (
      <div className="progress-indicator page">
        {
          totalSectionsArray.map(section => {
            return this.renderSection(section);
          })
        }
      </div>
    );
  }
}

ProgressIndicator.propTypes = {
  sectionActive: PropTypes.number,
  totalSections:PropTypes.number.isRequired,
  progressText: PropTypes.object.isRequired
};

export default ProgressIndicator;
